import React,{ useEffect, useState } from 'react';
import { Document, Page, StyleSheet, View, PDFViewer, Image, Text} from '@react-pdf/renderer';
import { useStore } from '../../../../app/stores/store';
import {getfrrReportAddress,TitleWiseDashboard,getFrrInformData} from '../../../../app/models/Restoration';
import { toast } from 'react-toastify';
interface FrrPDFComponentProps {
  rowdata: TitleWiseDashboard;
}
const FRReportPdfconvert = ({rowdata}:FrrPDFComponentProps) => {
  const { RestorationStore } = useStore();
  const [loadData, setLoadData] = useState<getfrrReportAddress[]>([]);
  const [reportData,setReportData]=useState<getFrrInformData>({
    ffrNo:0,
    titleCode:'',
    ffrDate:'',
    inputFrame:'',
    noOfReel:'',
    outputFrame:'',
    clientRequirementLevel:'',
    resolution:'',
    generalSummary:'',
    updatedBy:'',
  });
  const styles = StyleSheet.create({
    fontWeight:{fontWeight:1000},
    boader: { border: '1px solid black' },
    rightBoader: { borderRight: '1px solid black' },
    removeTopBoader: { border: '1px solid black', borderTop: '0px solid black' },
    bottomBoader: { borderBottom: '1px solid black' },
    rightLeftBoader: { borderLeft: '1px solid black', borderRight: '1px solid black' },
    page: { padding: 30 },
    box: { flexDirection: 'row', backgroundColor: 'white', alignItems: 'center' },
    logo: { width: '70px', height: '30px', marginLeft: 30, marginRight: 30 },
    title: { fontSize: 14, fontWeight: 'bold' },
    table: { width: '100%' },
    row: { flexDirection: 'row',flexWrap: 'wrap' },
    balckcontentbox: { flexDirection: 'row', height: 15 },
    contentbox: { flexDirection: 'row', backgroundColor: 'white', height: 22 },
    projectDetails: {fontSize: 11, color: 'blueviolet', width: '100%', textAlign: 'center', height: 22, paddingTop: 5, paddingBottom: 2, fontWeight: 'bold'},
    tableTitle: { width: '30%', textAlign: 'left', fontSize: 10, padding: 3,fontWeight: 'bold'},
    tableData: { width: '70%', textAlign: 'left', fontSize: 10, padding: 3 },
    tableHeader: { backgroundColor: 'gray', fontSize: 9, fontWeight: 'bold', color: 'white', height: 22,paddingTop: 5,textAlign: 'center', flexWrap: 'wrap',},
    ChildTableData: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3},
     
  });
  const formatString = (str:string, maxLength:number) => {
    if (str.length > maxLength) {
      const part1 = str.slice(0, maxLength);
      const part2 = str.slice(maxLength);
      return `${part1}\n${part2}`;
    }
    return str;
  };
  
  const dataAddressLoad=async ()=> {
    try
    {
      await RestorationStore.getFfrAddress(rowdata.title_Code);
      setLoadData(RestorationStore.getFrrReportAddress);
    }
    catch{toast.error('Error fetching data');}};
    const reportAPI=async()=>{
      try{
        await RestorationStore.getFrrInformation(rowdata.title_Code);
        setReportData(RestorationStore.getFrrInformData);
        dataAddressLoad();
      }
      catch
    {toast.error('Error fetching data');}};

useEffect(()=>{
  reportAPI();
  // eslint-disable-next-line 
},[]);

  const mydocument = (
    <Document>
      <Page style={[styles.page,styles.boader]} size="A4" wrap>
        <View style={[styles.box,styles.boader, { flexDirection: 'row', height: 75, backgroundColor: 'white' }]} >
          <Image src={'../assets/PrasadCorp.jpg'} style={styles.logo} />
          <Text style={styles.title}>Final Restoration Report</Text>
        </View>
        <View style={[styles.contentbox,styles.removeTopBoader]}>
          <Text style={{ width:'50%', textAlign:'left', fontSize:9 ,padding:5, fontWeight: 'bold'}}>FRR Serial Number:{reportData.ffrNo}</Text>
          <Text style={{ width:'50%', textAlign:'right', fontSize:9,padding:5}}>FRR Generate Date:{reportData.ffrDate.toString()}</Text>
        </View>
        <View style={[styles.table,styles.removeTopBoader]}>
          <Text style={[styles.projectDetails,styles.bottomBoader]}>Project Details</Text>
          <View style={[styles.row,styles.bottomBoader]}>
            <Text style={[styles.tableTitle,styles.rightBoader,styles.fontWeight]}>Title</Text>
            <Text style={styles.tableData}>{rowdata.title_Name}</Text>
          </View>
          <View style={[styles.row,styles.bottomBoader]}>
            <Text style={[styles.tableTitle,styles.rightBoader]}>Input Format</Text>
            <Text style={styles.tableData}>{reportData.inputFrame}</Text>
          </View>
          <View style={[styles.row,styles.bottomBoader]}>
            <Text style={[styles.tableTitle,styles.rightBoader]}>Output Format</Text>
            <Text style={styles.tableData}>{reportData.outputFrame}</Text>
          </View>
          <View style={[styles.row,styles.bottomBoader]}>
            <Text style={[styles.tableTitle,styles.rightBoader]}>Client Requirement Restoration Level Requested</Text>
            <Text style={styles.tableData}>{reportData.clientRequirementLevel}</Text>
        </View>
        <View style={[styles.row]}>
          <Text style={[styles.tableTitle,styles.rightBoader,{width:'15%'}]}>Reels #</Text>
          <Text style={[styles.tableTitle,styles.rightBoader,{width:'20%'}]}>{reportData.noOfReel}</Text>
          <Text style={[styles.tableTitle,styles.rightBoader,{width:'15%'}]}>Resolution</Text>
          <Text style={[styles.tableTitle,styles.rightBoader,{width:'15%'}]}>{reportData.resolution}</Text>
          <Text style={[styles.tableTitle,styles.rightBoader,{width:'20%'}]}>Total Frames</Text>
          <Text style={[styles.tableTitle,{width:'15%'}]}>{rowdata.allocated_Frames}</Text>
        </View>
        </View>
        <View style={styles.table}>
        <Text style={[styles.projectDetails,styles.rightLeftBoader,styles.bottomBoader]}>General Summary</Text>
        <Text style={[styles.ChildTableData,styles.removeTopBoader]}>{reportData.generalSummary}</Text>
        </View>
        <View style={[styles.table]}>
        <Text style={[styles.projectDetails,styles.rightLeftBoader,styles.bottomBoader]}>Addressing Details</Text>
        <View style={[styles.row,styles.removeTopBoader]}>
        <Text style={[styles.tableHeader,styles.rightBoader,{width:'15%'}]}>Cluster Name</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'15%'}]}>Reel</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'10%'}]}>Start Frame</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'10%'}]}>End Frame</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'10%'}]}>Total Frames</Text>
          <Text style={[styles.tableHeader,{width:'40%'}]}>Comments</Text>
        </View>
        {loadData!==null && loadData.length> 0 ? (loadData.map((item, index) => (
        <View style={[styles.row, styles.removeTopBoader]} key={index}>
          
          <Text wrap={true} style={[styles.ChildTableData, styles.rightBoader, {flexShrink: 1, flexGrow: 1, flexBasis: 'auto',textAlign: 'center',padding: 10}]}>{formatString(item.clusterName, 23)}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '15%', textAlign: 'center', padding: 10}]}>{item.reelName}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '10%', textAlign: 'center', padding: 10}]}>{item.startFrame}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '10%', textAlign: 'center', padding: 10}]}>{item.endFrame}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '10%', textAlign: 'center', padding: 10}]}>{item.totalFrame}</Text>
          <Text style={[styles.ChildTableData, {width: '40%',textAlign: 'center',padding: 10}]}>{item.comments}</Text>
        </View>
      ))):
      <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ChildTableData,{width: '100%',textAlign:'center'}]}>{'No Data Available'}</Text>
      </View>
      }
        </View>
      </Page>
    </Document>
  );
  
  return (
    <div>
       <PDFViewer width="100%" height="1000">
      {mydocument}
    </PDFViewer>
    </div>
    
  );
};

export default FRReportPdfconvert;
